import { z } from 'zod'

const TEMP_STRING = '###'

export const PASSWORD_POLICY_CONFIG = {
  no_more_than_two_identical_characters: {
    label: 'No more than 2 identical characters in a row',
    regex: `/^(?!.*(.)\\1\\1).+$/`
  },
  must_include_special_characters: {
    label: 'Special characters (!@#$%^&*)',
    regex: `/^(?=.*[!@#$%^&*(),.?":{}|<>]).*$/`
  },
  must_include_lower_upper_number: {
    label: 'Lower case (a-z), upper case (A-Z) and numbers (0-9)',
    regex: '/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d).*$/'
  },
  minimum_characters: {
    label: `Must have ${TEMP_STRING} characters in length`,
    regex: `/^.{${TEMP_STRING},255}$/`
  },
  non_empty: {
    label: 'Non-empty password required',
    regex: `/^(?!\\s*$).*/`
  }
}

export const replaceTempString = (str: string, value: string) => {
  const regex = new RegExp(TEMP_STRING, 'g')
  return str.replace(regex, value || '0')
}

export type PASSWORD_POLICY_NAME = keyof typeof PASSWORD_POLICY_CONFIG

export const schema = z.object({
  no_more_than_two_identical_characters: z.object({
    is_enabled: z.boolean(),
    min_length: z.string().optional()
  }),
  must_include_special_characters: z.object({
    is_enabled: z.boolean(),
    min_length: z.string().optional()
  }),
  must_include_lower_upper_number: z.object({
    is_enabled: z.boolean(),
    min_length: z.string().optional()
  }),
  minimum_characters: z
    .object({
      is_enabled: z.boolean(),
      min_length: z.string().trim()
    })
    .superRefine((data, ctx) => {
      if (data.is_enabled && !data.min_length) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Required',
          path: ['min_length']
        })
      }
    }),
  non_empty: z.object({
    is_enabled: z.boolean(),
    min_length: z.string().optional()
  })
})

export type TField = z.infer<typeof schema>
